<template>
    <div>
        <h3>Лого</h3>
        <div class="mt-2">
            <button @click="triggerFileInput" type="button"
                    class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Загрузить
            </button>
            <input type="file" class="hidden" v-on:change="onChangeFile" ref="fileInput">

            <div class="flex mt-2">
                <template v-for="item in this.logos">
                    <div
                        class="group relative cursor-pointer p-1 bg-purple-50 rounded mr-2 inline-block w-12"
                        :class="{'border border-purple-900' : item.publicUrl === logo}"
                        @click="selectLogo(item)"
                    >
                        <img :src="item.publicUrl" alt="">
                        <div
                            @click.prevent="deleteLogo(item)"
                            v-if="!item.isSystem" class="group-hover:block hidden hover:bg-gray-100 absolute w-6 h-6 border rounded-full right-0 -top-4 text-red-700 cursor-pointer bg-white p-1">
                            <TrashIcon aria-hidden="true" />
                        </div>
                    </div>
                </template>
            </div>

            <div class="flex mt-2">
                <vue-short-toggle v-model="removeBackground" class="mr-2"></vue-short-toggle>
                <div class="block text-sm font-medium text-gray-700">Удалить фон</div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeLogosStore} from "@/scripts/store/qr_code_logos.store";
import VueShortToggle from "@/scripts/components/app/common/vue-short-toggle.vue";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import {
    TrashIcon,
} from '@heroicons/vue/24/outline'
export default {
    name: "Logo",
    components: {
        VueShortToggle,
        TrashIcon
    },
    data() {
        return {
            isEnable: false,
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapState(qrCodeLogosStore, ['logos', 'loading']),
        ...mapState(qrCodeFormStore, ['style']),
        logo: {
            get() {
                return this.style.logo.logo
            },
            set(val) {
                this.updateLogoStyle({logo: val})
            }
        },
        removeBackground: {
            get() {
                return this.style.logo.removeBackground
            },
            set(val) {
                this.updateLogoStyle({removeBackground: val})
            }
        }
    },
    watch: {
        isEnable() {
            if (!this.isEnable) {
                this.deleteLogoStyle()
            }
        }
    },
    methods: {
        ...mapActions(qrCodeLogosStore, ['uploadNew', 'init', 'delete']),
        ...mapActions(qrCodeFormStore, ['updateLogoStyle', 'deleteLogoStyle']),
        async onChangeFile(e) {
            const logo = await this.uploadNew(this.$refs.fileInput.files[0])
            this.logo = logo.publicUrl
        },
        triggerFileInput() {
            this.$refs.fileInput.click()
        },
        selectLogo(logo) {
            this.logo = logo.publicUrl
        },
        deleteLogo(logo) {
            this.delete(logo)
        }

    }
}
</script>

<style scoped>

</style>
